module.exports = __webpack_public_path__ + "img/you.de48f518.png";